<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="50%"
    >
    <el-alert      
      type="warning"
      :closable="false"
      show-icon
    >
      <div>
        快麦通商品资料需要和ERP系统商品资料进行关联，才能进行如下操作：①加入分销小店；②正常进行交易履约发货流程；
      </div>
    </el-alert>
    <el-row style="margin-top: 10px;">
      <el-col class="title">以下商品将同步至系统资料，请确认：</el-col>
      <template v-if="skuObj.addScmBaseSku.length || skuObj.updateScmBaseSku.length">
        <el-col class="mrg-b-5" v-if="skuObj.addScmBaseSku.length">
          <span class="tips">{{skuObj.addScmBaseSku.length}}</span>个SKU将 <span class="tips">新增</span> 至系统资料
        </el-col>
        <el-col class="sku-list mrg-b-5" v-if="skuObj.addScmBaseSku.length">商品编码：
          <span>{{skuObj.addScmBaseSku[0]}}</span>
          <span v-if="skuObj.addScmBaseSku.length > 1">...</span>
        </el-col>
        <div v-if="skuObj.updateScmBaseSku.length >= 1">
          <el-col v-for="item in self_syncContent" :key="item" class="mrg-b-5">
           <span class="tips">{{skuObj.updateScmBaseSku.length}}</span> 个SKU将 <span class="tips">修改</span>系统资料 【{{SYNCCONTENT_MAP[item]}}】
        </el-col>
        </div>
      </template>
      <template v-if="skuObj.addScmBaseItem.length || skuObj.updateScmBaseItem.length">
        <el-col class="mrg-b-5" v-if="skuObj.addScmBaseItem.length">
         商品将 <span class="tips">新增</span> 至系统资料
        </el-col>
        <el-col class="sku-list mrg-b-5" v-if="skuObj.addScmBaseItem.length">商品编码：
            <span>{{skuObj.addScmBaseItem[0]}}</span>
            <span v-if="skuObj.addScmBaseItem.length > 1">...</span>
        </el-col>
        <template v-if="skuObj.updateScmBaseItem.length >= 1">
            <el-col v-for="item in self_syncContent" :key="item" class="mrg-b-5">
              商品将 <span class="tips">修改</span>系统资料 【{{SYNCCONTENT_MAP[item]}}】
            </el-col>
        </template>
      </template>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">返回修改</el-button>
      <el-button type="primary" @click="fetch_checkOuterIdRepeat(true)">跳过同步</el-button>
      <el-button type="primary" @click="fetch_checkOuterIdRepeat(false)">确 定</el-button>
    </span>
 </el-dialog>
</template>

<script>
import {SYNCCONTENT_MAP} from '../dictionary'
import {getCheckOuterIdRepeat} from '@/servers/prod/center'
export default {
  data() {
    return {
      SYNCCONTENT_MAP,
      dialogVisible: false,
      skuObj: {
        addScmBaseItem: [],
        updateScmBaseItem: [],
        addScmBaseSku: [],
        updateScmBaseSku: []
      },
      formData: {
        syncContent: []
      },
      self_syncContent: [],
      type: ''
    }
  },
  methods: {
    method_open(res, formData, type, checkSyncContent) {
      this.dialogVisible = true;
      this.skuObj = {...res};
      this.formData = formData;
      this.type = type;
      this.self_syncContent = checkSyncContent;
    },
    async fetch_checkOuterIdRepeat(isSkip) {
      

      const res = await getCheckOuterIdRepeat({
        ...this.formData,
        repeatOuterIds: this.skuObj.addScmBaseItem.length ? this.skuObj.addScmBaseItem : this.skuObj.addScmBaseSku
      })
      if(!res) return;
      if(res.repeatIds && res.repeatIds.length) {
        let message ='';
        if(res.pureType) {
          message = '【系统资料】中存在SPU编码相同的非纯商品，生成新的【系统资料】编码SPU编码+123；点击确定新建，点击取消放弃';
        } else {
          message = '当前创建的sku编码与已存在【系统资料】中商品的款式编码重复，需要新建商品编码+123；点击确定创建，点击取消放弃'
        }
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          width: '500px',
        }).then(() => {
          this.dialogVisible = false;
          this.$emit('edit', this.type, res.repeatIds, isSkip);
        }).catch(()=> {
          this.dialogVisible = false;
          this.$message({
            type: 'info',
            message: '已取消创建!'
          });
        })
      } else {
        this.dialogVisible = false;
        this.$emit('edit', this.type, null, isSkip);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  margin-bottom: 12px;
}
.tips{
  color: red;
}
.sku-list{
  background-color: #EEE;
  padding: 10px;
}
.mrg-b-5{
  margin-bottom: 5px;
}
</style>
